var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contatiner",class:_vm.hideList ? 'no-list': ''},[_c('div',{staticClass:"button",attrs:{"data-agl-cvt":"6"},on:{"click":function($event){return _vm.$emit('download')}}}),(!_vm.hideList)?_c('List',{on:{"start":function($event){return _vm.$emit('download')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }